import { createSlice } from "@reduxjs/toolkit";

const appLevelSlice = createSlice({
  name: "applevel",
  initialState: {
    factoryList: [],
    qualityList: [],
    productList: [],
    vendorList: [],
    cartoonList: [],
    plasticList: [],
    moldList: [],
    leafList: [],
    isSuccess: false,
    isLoading: false,
    errMsg: "",
    isAppLevelError: false,
  },
  reducers: {
    getFactoryList: (state, action) => {
      state.factoryList = action.payload?.map((item) => {
        return { value: item.id, label: item.name, type: "factory" };
      });
    },
    getQualityList: (state, action) => {
      state.qualityList = action.payload.map((item) => {
        return { value: item.id, label: item.name, type: "quality" };
      });
    },
    getProductList: (state, action) => {
      state.productList = action.payload.data.map((item) => {
        return {
          value: item.id,
          label: item.name,
          type: action.payload.valueLable,
        };
      });
    },
    getVendorList: (state, action) => {
      state.vendorList = action.payload.data.map((item) => {
        return {
          value: item.id,
          label: item.name,
          type: "vendor",
        };
      });
    },
    getMoldList: (state, action) => {
      state.moldList = action.payload.data.map((item) => {
        return {
          value: item.id,
          label: item.name,
          type: "mold",
        };
      });
    },
    getCartoonList: (state, action) => {
      state.cartoonList = action.payload.data.map((item) => {
        return {
          value: item.id,
          label: item.name,
          type: "cartoon_type",
        };
      });
    },
    getPlasticList: (state, action) => {
      state.plasticList = action.payload.data.map((item) => {
        return {
          value: item.id,
          label: item.name,
          type: "plastic_type",
        };
      });
    },
    getLeafList: (state, action) => {
      state.leafList = action.payload.data.map((item) => {
        return {
          value: item.id,
          label: item.name,
          type: "leaf_store_ware_house",
        };
      });
    },
    // plasticList
    setLoadingState: (state) => {
      state.isLoading = !state.isLoading;
    },
    setIsSuccess: (state, action) => {
      state.isSuccess = action.payload;
    },
    setError: (state, action) => {
      state.errMsg = action.payload.msg;
      state.isAppLevelError = action.payload.isError;
    },
  },
});

export const appLevelSliceActions = appLevelSlice.actions;

export default appLevelSlice.reducer;
